import { Card } from 'antd'
import React, { Component } from 'react'
import './about.css'
import TitleD from '../title/Title'
import image from '../../images/photo.jpg'
import { Image } from 'antd'
import { Typography } from 'antd'

const { Title } = Typography

const { Meta } = Card

const tabList = [
  {
    key: 'info',
    tab: 'Инфо',
  },
  {
    key: 'hardSkills',
    tab: 'Hard-skills',
  },
  {
    key: 'softSkils',
    tab: 'Soft-skills',
  },
  {
    key: 'knownSkills',
    tab: 'Знаком с',
  },
]

const contentList = {
  info: (
    <>
      <Title level={5}>Титюнников Андрей Викторович</Title>
      <p>
        Занимаюсь web-разработкой, в последнее время увлечен
        front-end сосоставляющей, но на начальном уровне
        знаком с back-end (Django+Postgres и Laravel+MySQL)
      </p>
    </>
  ),
  hardSkills: (
    <ul>
      <li>React 17</li>
      <li>ES6</li>
      <li>Webpack</li>
      <li>Redux</li>
      <li>React-Router</li>
      <li>SCSS</li>
    </ul>
  ),
  softSkils: (
    <ul>
      <li>Ответственность</li>
      <li>Дисциплинированность</li>
      <li>Целеустремленность</li>
      <li>Трудолюбие</li>
      <li>Исполнительность</li>
    </ul>
  ),
  knownSkills: (
    <ul>
      <li>GIT</li>
      <li>Project management systems</li>
      <li>PHP7(Laravel 5)</li>
      <li>Python3(Django 2)</li>
      <li>PostgreSQL11/MySQL5</li>
    </ul>
  ),
}

class AboutCard extends Component {
  state = {
    key: 'info',
    noTitleKey: 'app',
  }

  onTabChange = (key, type) => {
    console.log(key, type)
    this.setState({ [type]: key })
  }

  render() {
    return (
      <>
        <TitleD size="3" marginTop="10" />
        <Image width={200} src={image} />
        <Card
          tabList={tabList}
          className="AboutCard"
          hoverable
          style={{
            width: '375px',
            height: '250px',
            cursor: 'default',
          }}
          activeTabKey={this.state.key}
          onTabChange={key => {
            this.onTabChange(key, 'key')
          }}
        >
          <Meta description={contentList[this.state.key]} />
        </Card>
      </>
    )
  }
}

export default AboutCard
